import {
	GET_ACTIVITY,
	ACTIVITY_CHANGED,
	ADD_COMMENT,
	COMMENT_RECEIVED,
	SET_ACTIVITY_LOADING
} from '../constants/activity.constants';

// `entity` (not `type`) carries the subject's kind, since `type` is taken by the redux action type.
export const getActivity = (entity, objectId) => ({ type: GET_ACTIVITY, entity, objectId });
export const activityChanged = (entity, objectId, entries) => ({ type: ACTIVITY_CHANGED, entity, objectId, entries });
export const addComment = (entity, objectId, text) => ({ type: ADD_COMMENT, entity, objectId, text });
export const commentReceived = entry => ({ type: COMMENT_RECEIVED, entry });
export const setActivityLoading = (entity, objectId, loading) =>
	({ type: SET_ACTIVITY_LOADING, entity, objectId, loading });
